/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface TuteurHistorySearch
 */
export interface TuteurHistorySearch {
    /**
     * 
     * @type {number}
     * @memberof TuteurHistorySearch
     */
    idtuteur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TuteurHistorySearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TuteurHistorySearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurHistorySearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurHistorySearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TuteurHistorySearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurHistorySearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TuteurHistorySearch interface.
 */
export function instanceOfTuteurHistorySearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurHistorySearchFromJSON(json: any): TuteurHistorySearch {
    return TuteurHistorySearchFromJSONTyped(json, false);
}

export function TuteurHistorySearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurHistorySearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TuteurHistorySearchToJSON(value?: TuteurHistorySearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteur': value.idtuteur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

